<p-dialog [modal]="true" [position]="position()" [draggable]="draggable()" [resizable]="resizable()" [dismissableMask]="dissmissableMask()" [(visible)]="visible">
    <ng-template pTemplate="header">
        <strong>{{ 'QR_CODE' | translate }}</strong>
    </ng-template>

    @if (personQuery) {
        <div class="qr-code-container">
            @if (showId()) {
                <span class="p-text-secondary qr-code-label">ID: {{ personQuery.queryId }}</span>
            }
            <app-qr-code [value]="personQuery.consentUrlBoxed" />
            @if (showLink && !isProd) {
                <a [href]="personQuery.consentUrlBoxed" target="_blank" rel="noopener noreferrer" style="text-decoration: underline;">{{ 'GO_TO_LINK' | translate }}</a>
            }
        </div>
    }
</p-dialog>
